var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGyRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1778830004857,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8697,
    width: 256,
    height: 256,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M828.075928 697.17319l180.442802-180.442802c1.548127-1.548127 2.236183-3.612296 2.236183-6.020494 0-1.376113-0.344028-3.956325-2.408197-6.020494l-0.344028-0.344028-179.92676-180.098774c-1.548127-1.548127-3.78431-2.408198-6.192508-2.408197-1.376113 0-3.956325 0.344028-6.020494 2.408197-1.548127 1.548127-2.408198 3.612296-2.408197 6.020494 0 1.376113 0.344028 3.956325 2.408197 6.192508l166.509659 166.509659h-961.558878c-4.816395 0-8.600706 3.78431-8.600705 8.600706 0 4.472367 3.956325 8.600706 8.600705 8.600705h960.010751l-164.961532 164.961532c-1.548127 1.548127-2.408198 3.78431-2.408197 6.192508 0 1.376113 0.344028 3.956325 2.408197 6.020494 1.548127 1.548127 3.78431 2.408198 6.020494 2.408198 1.376113-0.172014 4.128339-0.516042 6.192508-2.580212z",
    "p-id": 8698
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyRightArrow);
export default __webpack_public_path__ + "static/media/gyRightArrow.471c8a0b30fc15a0d811967d3c0b47dd.svg";
export { ForwardRef as ReactComponent };